module.exports = __webpack_public_path__ + "static/img/banner2.b513adff.jpg";